import { Toolbar, SaveButton } from 'react-admin';
export const WriteToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton redirect="list" />
  </Toolbar>
);
